var map = {
	"./ClientInfoTD": "G2NP",
	"./ClientInfoTD.js": "G2NP",
	"./PotentialClient.scss": "PETx",
	"./TagListTD": "Pn1/",
	"./TagListTD.js": "Pn1/",
	"./TagsField": "ITiw",
	"./TagsField.js": "ITiw",
	"./constant": "EjrW",
	"./constant.js": "EjrW",
	"./ducks": "tCuI",
	"./ducks.js": "tCuI",
	"./images/potential-cn.png": "bhhv",
	"./images/potential-en.png": "EoL8",
	"./index": "Fltp",
	"./index.js": "Fltp",
	"./locale": "aKPj",
	"./locale.js": "aKPj",
	"./table-fields": "kugd",
	"./table-fields.js": "kugd",
	"./table-settings": "WcKJ",
	"./table-settings.js": "WcKJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;



//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/PotentialClient ^\.\/.*$
// module id = 18
// module chunks = 0